import { render, staticRenderFns } from "./ApplicationFormFeesStaff.vue?vue&type=template&id=0f67ac07&scoped=true&"
import script from "./ApplicationFormFeesStaff.vue?vue&type=script&lang=js&"
export * from "./ApplicationFormFeesStaff.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationFormFeesStaff.vue?vue&type=style&index=0&id=0f67ac07&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f67ac07",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardText,VCol,VCombobox,VDatePicker,VMenu,VRow,VSnackbar,VTextField})
